import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import './RDSelect.scss';

const { Option } = Select;

const RDSelect = ({
  options,
  selectStyles,
  placeholder,
  dropdownRender,
  selectValue,
  handleChange,
  showSearch,
  selectDisabled,
}) => (
  <Select
    style={selectStyles}
    placeholder={placeholder}
    dropdownRender={dropdownRender}
    value={selectValue}
    onChange={handleChange}
    showSearch={showSearch}
    disabled={selectDisabled}
  >
    {options.map(({ key, value, ...props }) => (
      <Option value={key} key={key} additional={props}>
        {value}
      </Option>
    ))}
  </Select>
);

RDSelect.defaultProps = {
  selectStyles: {},
  placeholder: '',
  options: [],
  dropdownRender: undefined,
  selectValue: '',
  handleChange: () => {},
  showSearch: false,
  selectDisabled: false,
};

RDSelect.propTypes = {
  /** Select styles */
  selectStyles: PropTypes.shape({}),
  /** Select placeholder */
  placeholder: PropTypes.string,
  /** Select options  */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
      additional: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.shape({})]),
    }),
  ),
  /** Customize select content */
  dropdownRender: PropTypes.func,
  /** Current selected option */
  selectValue: PropTypes.string,
  /** Called when select an option or input value change */
  handleChange: PropTypes.func,
  /** Whether show search input in single mode */
  showSearch: PropTypes.bool,
  /** Whether disabled select */
  selectDisabled: PropTypes.bool,
};

export default RDSelect;
